import styled from "styled-components";

export function EmptyState() {
    return (
        <EmptyStateWrapper>
            <p className="empty-message">Não encontramos registros para os filtros aplicados. Ajuste os filtros e tente novamente.</p>
        </EmptyStateWrapper>
    );
}

const EmptyStateWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3rem 0;

    .empty-message {
        font-family: Lato;
        font-size: 1rem;
        color: #7A7A7A;
        margin: 0;
    }
`;
